import { useQuizQuestionsDragNDropStore } from "@/store/quiz-question-drag";
import Mention from "@tiptap/extension-mention";
import StarterKit from "@tiptap/starter-kit";
import { Editor } from "@tiptap/vue-3";
import { createSuggestion } from "@/components/TipTap/suggestion";

export function restoreItemsAndOptions(questionStore: any) {
  useQuizQuestionsDragNDropStore.resetResponses();
  const restoredQuestionItems = questionStore.responseContent?.items?.map(
    (item, itemIndex) => {
      let correctOptions = item.correctOptions.map((opt) => {
        return JSON.parse(opt);
      });
      correctOptions = correctOptions.map((option) => ({
        ...option,
        itemGroup: itemIndex,
      }));
      let restoredAnswerText = item.answerText;

      correctOptions.forEach((option) => {
        const regex = new RegExp(`\\[resposta-hidden:${option.id}\\]`, "g");
        restoredAnswerText = restoredAnswerText.replace(
          regex,
          `<span class="mention target-dad" data-type="mention" data-id="${option.id}" data-label="${option.name}">@${option.name}</span>`
        );
      });
      useQuizQuestionsDragNDropStore.setResponses(correctOptions);
      return { ...item, answerText: restoredAnswerText };
    }
  );

  Object.assign(
    useQuizQuestionsDragNDropStore?.responseContent?.items,
    restoredQuestionItems
  );

  const itemsEditorContent = restoredQuestionItems.map((item) => {
    return new Editor({
      content: item.answerText,
      extensions: [
        StarterKit,
        Mention.configure({
          HTMLAttributes: { class: "mention target-dad" },
          suggestion: createSuggestion("dragAndDrop"),
          deleteTriggerWithBackspace: true,
        }),
      ],
    });
  });

  Object.assign(useQuizQuestionsDragNDropStore.items, [...itemsEditorContent]);

  const restoredOptions = questionStore.responseContent?.extraOptions?.map(
    (option) => {
      return JSON.parse(option);
    }
  );

  if (restoredOptions)
    Object.assign(useQuizQuestionsDragNDropStore.options, [...restoredOptions]);
}
